<template>
    <el-amap ref="map" class="amap-box" :vid="'amap-vue'"
      :zooms="zooms"
      :zoom="zoom"
      :mapStyle="mapStyle"
      :amap-manager="amapManager"
      :plugin="plugin"
      :events="events"
    >
    <div class="rider_status_box">
      <div class="rider_status_box-title">
        <span class="rider_status_box-title-large">骑手类型</span>
        <span class="rider_status_box-title-note">注: 只展示待处理订单</span>
      </div>
      <div class="rider_status_box-select_list">
        <el-select
        multiple
        collapse-tags
        size="small"
        placeholder="全部骑手"
        :value="workStatus"
        class="rider_status_box-select_list-select"
        @input="handleSelectWorkStatus"
      >
        <el-option
          v-for="item in riderStatusList"
          filterable
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.value !== 0 && workStatus.includes(0)">
        </el-option>
      </el-select>
      </div>
    </div>
    <!-- 骑手marker -->
    <el-amap-marker vid="rider-marker" 
      v-for="(rider, index) in riderMarkerList"
      :key="index"
      :position="[rider.lng, rider.lat]"
      :content-render="riderMarker.contentRender"
      :zIndex="200"
    ></el-amap-marker>
    <!-- 店铺marker  -->
    <el-amap-marker vid="shop-marker"
      v-for="shop in shopMarkerList"
      :key="shop.shop_id"
      :title="shop.shop_name"
      :position="[shop.shop_position[0], shop.shop_position[1]]"
      :content-render="shopMarker.contentRender"
      :zIndex="200"
    ></el-amap-marker>
    </el-amap>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { AMapManager } from 'vue-amap';
import StaticRiderMarker from 'components/AMap/StaticRiderMarker';
import StoreMarker from 'components/AMap/StoreMarker';
import { MAP_STYLE, MAP_FEATURES, AOI_COLOR, AOI_COLOR_TEXT, ORDER_FLOW_AOI, ORDER_FLOW_STORE } from 'common/constant';
const amapManager = new AMapManager();
/**
 * 获得多边形的中心点
 */
function getCenterPoint(path) {
  let x = 0.0;
  let y = 0.0;
  for (let i = 0; i < path.length; i++) {
    x += parseFloat(path[i].lng);
    y += parseFloat(path[i].lat);
  }
  x /= path.length;
  y /= path.length;
  return [x, y];
}
/**
 * 验证合法坐标
 */
function isValidPosition(position) {
  return position !== null && position[0] && position[1] && position[0] !== '' && position[1] !== '';
}

export default {
  name: 'MapView',
  data() {
    return {
      renderLater: [],
      amapManager,
      zooms: [3, 18],
      mapStyle: MAP_STYLE,
      zoom: 12,
      plugin: [{
        pName: 'ToolBar',
        position: 'RT',
        liteStyle: true,
      }],
      events: {
        init: () => {
          const mapObj = this.amapManager.getMap();
          mapObj.setFeatures(MAP_FEATURES);
          if (this.renderLater.length > 0) {
            this.renderLater.forEach(item => item.setMap(mapObj));
          }
          // 初始化订单轨迹
          // 实例订单轨迹对象
          const emptyLineStyle = {
            lineWidth: 0,
            fillStyle: null,
            strokeStyle: null,
            borderStyle: null,
          };

          AMapUI.load(['ui/misc/PathSimplifier'], (PathSimplifier) => {
            if (!PathSimplifier.supportCanvas) {
              console.log('当前环境不支持 Canvas！');
              return;
            }

            this.PathSimplifier = new PathSimplifier({
              zIndex: 450,
              autoSetFitView: false,
              clickToSelectPath: false,
              map: mapObj, // 所属的地图实例
              getPath: pathData => pathData.path,
              getHoverTitle: () => null,
              renderOptions: {
              // 将点、线相关的 style 全部置 emptyLineStyle
                pathLineStyle: {
                  strokeStyle: 'rgba(255,255,255,0)', // {string} 线颜色，比如 red, rgb(255,0,0), rgba(0,0,0,1)等
                  lineWidth: 0, // {number}   线宽度
                  borderStyle: 'rgba(255,255,255,0)', // {string}  描边颜色
                  borderWidth: 0, // {number}  描边宽度
                },
                pathLineHoverStyle: {
                  strokeStyle: 'rgba(255,255,255,0)',
                  borderStyle: 'rgba(255,255,255,0)',
                },
                pathLineSelectedStyle: {
                  width: 10, // {number} 巡航器形状宽度
                  height: 10, // {number} 巡航器形状高度
                },
                keyPointStyle: emptyLineStyle,
                startPointStyle: emptyLineStyle,
                endPointStyle: emptyLineStyle,
                keyPointHoverStyle: emptyLineStyle,
                keyPointOnSelectedPathLineStyle: emptyLineStyle,
              },
            });
            this.createPath();
          });
        },
      },
      aoiShopDeliverPolygon: {},
      aoiMap: {},
      aoiTextMap: {},
      aoiMapEvent: [],
      PathSimplifier: null,
    };
  },
  mounted() {
  },
  watch: {
    AoiShopInfo() {
      // 生成共享单元范围
      if (this.AoiShopMsg && this.AoiShopMsg.aoi_id) {
        this.renderAoi();
      } else {
        this.clearAoi();
      }
    },
    ViewMode() {
      setTimeout(() => {
        const map = this.amapManager.getMap();
        map && map.setFitView();
        map && map.zoomOut();
      }, 0);
    },
    riderList() {
      setTimeout(() => {
        const map = this.amapManager.getMap();
        map && map.setFitView();
        map && map.zoomOut();
      }, 0);
    },
    pendingList() {
      if (this.PathSimplifier) {
        // 销毁现存的所有轨迹巡航器
        this.PathSimplifier.clearPathNavigators();
        this.createPath();
      }
    },
  },
  computed: {
    ...mapState(['initData']),
    ...mapState({
      ViewMode: ({ aside }) => aside.ViewMode,
      AoiShopInfo: ({ aside }) => aside.AoiShopInfo,
      pendingList: ({ orderList }) => orderList.pendingList,
      riderList: ({ riderList }) => riderList.list,
      riderStatusList: ({ riderList }) => riderList.riderStatusList,
      workStatus: ({ riderList }) => riderList.workStatus,
    }),
    ...mapGetters(['AoiShopMsg']),
    riderMarkerList() {
      return this.riderList.filter(rider => rider.lng && rider.lat);
    },
    shopMarkerList() {
      return this.AoiShopInfo.filter(shop => shop.shop_position &&
      shop.shop_position[0] && shop.shop_position[1]);
    },
    riderMarker() {
      const self = this;
      return {
        contentRender: (h, instance) => {
          const rider = self.riderMarkerList[instance.$vnode.key];
          if (rider) {
            return h(StaticRiderMarker, {
              props: {
                name: rider.rider_name,
                unfinishNum: rider.delivery_order_num,
                distance: rider.distance,
              },
            });
          }
          return null;
        },
      };
    },
    shopMarker() {
      const self = this;
      return {
        contentRender: (h, instance) => {
          const store = self.shopMarkerList.find(item => item.shop_id === instance.$vnode.key);
          if (store) {
            return h(StoreMarker, {
              props: {
                name: store.shop_name,
                deliver_type: store.deliver_type,
                brand_icon: store.brand_icon,
              },
            });
          }
          return null;
        },
      };
    },
    orderPath() {
      const paths = [];
      this.pendingList.forEach((item, index) => {
        const fromPosition = [item.shop_lng, item.shop_lat];
        const toPosition = [item.user_lng, item.user_lat];
        if (isValidPosition(fromPosition) && isValidPosition(toPosition)) {
          const lineColor = item.dispatch_type === 1 ? ORDER_FLOW_AOI : ORDER_FLOW_STORE;
          paths.push({
            name: index,
            path: [fromPosition, toPosition],
            lineColor,
          });
        }
      });
      return paths;
    },
  },
  methods: {
    ...mapActions('riderList', ['handleSelectWorkStatus']),
    createPath() {
      this.PathSimplifier.setData(this.orderPath);
      // 添加轨迹
      this.orderPath.forEach((item, index) => {
        this.PathSimplifier.createPathNavigator(index, {
          loop: true, // 循环播放
          speed: 1800, // 巡航速度，单位千米/小时
          pathNavigatorStyle: {
            width: 12,
            height: 12,
            strokeStyle: null,
            fillStyle: null,
            // 经过路径的样式
            pathLinePassedStyle: {
              lineWidth: 1.6,
              strokeStyle: item.lineColor,
            },
          },
        }).start();
      });
    },
    clearAoi() {
      const map = this.amapManager.getMap();
      if (map) {
        map.remove(this.aoiMap);
        map.remove(this.aoiTextMap);
        // 清除绑定事件
        this.aoiMapEvent.forEach((event) => {
          AMap.event.removeListener(event);
        });
        this.aoiMapEvent = [];
        this.aoiMap = {};
        this.aoiTextMap = {};
      }
    },
    renderAoi() {
      this.clearAoi();
      const mapObj = this.amapManager.getMap();
      const deliverMapOverAll = [];
      this.AoiShopInfo.forEach((shop) => {
        if (shop.deliver_type !== 1) {
          // 只关注共享店铺
          if (shop.polygon !== null && shop.polygon.length > 0) {
            // 有配送范围的店铺 收集配送范围坐标点
            shop.polygon.map(lnglat => deliverMapOverAll.push(lnglat));
          } else {
            // 没有配送范围的店铺 收集店铺位置坐标
            shop.shop_position && deliverMapOverAll.push(shop.shop_position);
          }
        }
      });
      if (deliverMapOverAll.length > 0) {
        // 以餐厅配送范围形成多边形区域
        // 以多边形矩形作为共享单元配送范围
        this.aoiShopDeliverPolygon = new AMap.Polygon({ path: deliverMapOverAll });
        this.aoiMap = new AMap.Rectangle({
          bounds: this.aoiShopDeliverPolygon.getBounds(),
          fillOpacity: 0, // 填充透明度
          strokeOpacity: 1, // 线透明度
          strokeWeight: 1, // 线宽
          zIndex: 200, // 多边形覆盖物的叠加顺序
          bubble: true, // 将覆盖物的鼠标或touch等事件冒泡到地图上
          strokeColor: AOI_COLOR, // 线颜色
          fillColor: AOI_COLOR, // 填充色
        });
        // 设置共享单元名称 Text
        // 计算位置
        const textPosition = getCenterPoint(deliverMapOverAll);
        this.aoiTextMap = new AMap.Text({
          text: this.AoiShopMsg ? this.AoiShopMsg.label : '',
          position: textPosition,
          zIndex: 250,
          visible: false,
          style: {
            backgroundColor: 'rgba(255,255,255,0)',
            border: 'solid 1px rgba(255,255,255,0)',
            color: AOI_COLOR_TEXT, // aoi.aoi_type === 1 ? AOI_COLOR_TEXT : FAST_COLOR_TEXT,
            padding: '10px 20px',
            fontSize: '16px',
            fontWeight: '600',
          },
          bubble: true,
        });

        // addListener
        const aoiEventMouseover = AMap.event.addListener(
          this.aoiMap,
          'mouseover',
          () => {
            this.aoiMap.setOptions({
              fillOpacity: 0.15, // 填充透明度
            });
            this.aoiTextMap.show();
          },
        );
        const aoiTextEventMouseover = AMap.event.addListener(
          this.aoiTextMap,
          'mouseover',
          () => {
            this.aoiMap.setOptions({
              fillOpacity: 0.15, // 填充透明度
            });
            this.aoiTextMap.show();
          },
        );
        const aoiEventMouseout = AMap.event.addListener(
          this.aoiMap,
          'mouseout',
          () => {
            this.aoiMap.setOptions({
              fillOpacity: 0, // 填充透明度
            });
            this.aoiTextMap.hide();
          },
        );
        const aoiTextEventMouseout = AMap.event.addListener(
          this.aoiTextMap,
          'mouseout',
          () => {
            this.aoiMap.setOptions({
              fillOpacity: 0, // 填充透明度
            });
            this.aoiTextMap.hide();
          },
        );

        this.aoiMapEvent.push(
          aoiEventMouseover,
          aoiEventMouseout,
          aoiTextEventMouseover,
          aoiTextEventMouseout,
        );

        if (mapObj) {
          this.aoiMap.setMap(mapObj);
          this.aoiTextMap.setMap(mapObj);
        } else {
          this.renderLater.push(this.aoiMap);
          this.renderLater.push(this.aoiTextMap);
        }
      }
    },
  },
};
</script>

<style lang="less">
.rider_status_box {
  position: absolute;
  background-color: #fff;
  left: 190px;
  bottom: 30px;
  padding: 20px;

  &-title {
    margin-bottom: 15px;

    &-large {
      font-size: 16px;
      color: #000;
    }

    &-note {
      font-size: 12px;
      display: block;
      margin-top: 10px;
      color: #999999;
    }
  }
  &-select_list {
    width: 127px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/homepage/modules/MapView.vue